import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { registerSW } from 'virtual:pwa-register';
import { AuthProvider } from './features/auth/AuthContext';
import { captureInstallPrompt } from './features/install/install-prompt';
import './index.css';

// Before rendering: beforeinstallprompt can fire right after load, and only once.
captureInstallPrompt();
// Only does anything in a production build (the SW is disabled in `vite dev`).
registerSW({ immediate: true });

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
